module.exports = __webpack_public_path__ + "media/images/icon-star-cdd3137dc4516adb4b5306a287996ab3.svg";